<template>
  <div class="modal fade" id="approval-confirmation-modal" tabindex="-1" aria-labelledby="approvalConfirmationLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" :class="actionType === 'Approved' ? 'bg-success' : 'bg-danger'">
          <h5 class="modal-title text-white" id="approvalConfirmationLabel">
            <i :class="`mdi ${actionType === 'Approved' ? 'mdi-check-circle' : 'mdi-close-circle'} me-2`"></i>
            {{ actionType === 'Approved' ? 'Approve' : 'Reject' }} Leave Request
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="leaveRequest.names" class="mb-3">
            <div class="alert alert-light border">
              <div class="d-flex align-items-center">
                <div class="avatar-sm me-3">
                  <span class="avatar-title rounded-circle bg-soft-primary text-primary">
                    {{ getInitials(leaveRequest.names) }}
                  </span>
                </div>
                <div>
                  <h6 class="mb-1">{{ leaveRequest.names }}</h6>
                  <p class="mb-0 text-muted small">
                    {{ leaveRequest.leaveTypeName }} - {{ leaveRequest.totalDays }} Days
                  </p>
                  <p class="mb-0 text-muted small">
                    {{ formatDate(leaveRequest.startDate) }} to {{ formatDate(leaveRequest.endDate) }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <p class="text-muted mb-2">
              Are you sure you want to <strong :class="actionType === 'Approved' ? 'text-success' : 'text-danger'">
              {{ actionType.toLowerCase() }}
            </strong> this leave request?
            </p>
          </div>

          <div class="mb-3">
            <label for="remarks" class="form-label">
              Remarks <span class="text-muted">({{ actionType === 'Rejected' ? 'Required' : 'Optional' }})</span>
            </label>
            <textarea
                id="remarks"
                v-model="remarks"
                class="form-control"
                rows="4"
                :placeholder="actionType === 'Approved' ? 'Add any comments or conditions (optional)...' : 'Please provide reason for rejection...'"
            ></textarea>
            <div v-if="actionType === 'Rejected' && showError" class="text-danger small mt-1">
              Please provide a reason for rejection
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button
              type="button"
              :class="`btn ${actionType === 'Approved' ? 'btn-success' : 'btn-danger'}`"
              @click="confirmAction"
              :disabled="processing"
          >
            <span v-if="processing" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            <i v-else :class="`mdi ${actionType === 'Approved' ? 'mdi-check' : 'mdi-close'} me-1`"></i>
            {{ processing ? 'Processing...' : `Confirm ${actionType}` }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApprovalConfirmationModal",
  props: {
    leaveRequest: {
      type: Object,
      default: () => ({})
    },
    actionType: {
      type: String,
      default: 'Approved'
    }
  },
  data() {
    return {
      remarks: '',
      processing: false,
      showError: false
    };
  },
  watch: {
    // Reset remarks when modal is opened with new data
    leaveRequest: {
      handler() {
        this.remarks = '';
        this.showError = false;
      },
      deep: true
    },
    actionType() {
      this.remarks = '';
      this.showError = false;
    }
  },
  methods: {
    getInitials(name) {
      if (!name) return 'NA';
      return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    },
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return d.toLocaleDateString('en-US', options);
    },
    confirmAction() {
      // Validate remarks for rejection
      if (this.actionType === 'Rejected' && !this.remarks.trim()) {
        this.showError = true;
        return;
      }

      this.showError = false;
      this.processing = true;

      // Emit the confirmation with remarks
      this.$emit('confirm', {
        leaveRequest: this.leaveRequest,
        action: this.actionType,
        remarks: this.remarks.trim()
      });
    },
    resetProcessing() {
      this.processing = false;
    }
  }
};
</script>

<style scoped>
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
  width: 3rem;
  font-size: 1.2rem;
}

.bg-soft-primary {
  background-color: rgba(85, 110, 230, 0.1);
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.alert-light {
  background-color: #f8f9fa;
}
</style>